<template>
    <div class="complaint--layout">
        <div class="bc-container">
            <button class="btn btn-plain btn-plain-wicon button-close" type="button"
                    @click="() => { $store.commit('resetValidation'); back()}">
                <md-icon>arrow_back_ios</md-icon>
            </button>
        </div>

        <complaint-damage-form
            v-if="$route.hash === '#damage'"
            @submit="submitDamageForm"
            :edit="false"
            :loading="loading"
            :form="form"
        />
        <complaint-quality-form
            v-else-if="$route.hash === '#quality'"
            @submit="submitQualityForm"
            :edit="false"
            :loading="loading"
            :form="form"
        />

        <notification></notification>
    </div>
</template>

<script>
import config from '../plugins/config.js'
import axios from 'axios';
import Vue from 'vue'
import {MdIcon} from 'vue-material/dist/components'
import Notification from '../components/Notification.vue'
import ComplaintDamageForm from '../components/ComplaintDamageForm.vue'
import ComplaintQualityForm from '../components/ComplaintQualityForm.vue'
import {mapGetters} from 'vuex';

Vue.use(MdIcon)

export default {
    name: 'ComplaintCreate',

    components: {
        Notification,
        ComplaintDamageForm,
        ComplaintQualityForm
    },

    data() {
        return {
            loading: false,
            isLoggedIn: false,
            form: {
                name: '',
                phone: null,
                email: '',
                buyer_name: '',
                products: [],
                zip: '',
                county: '',
                city: '',
                street: '',
                house_number: '',
                installation_status: 'before',
                installation_date: '',
                delivery_note_number: null,
                delivery_note_files: null,
                delivery_note_files_preview: null,
                photo_of_dmg_files: null,
                photo_of_dmg_files_preview: null,
                warranty_file: null,
                warranty_file_preview: null,
                message: ''
            }
        }
    },

    methods: {
        async back() {
            if (! this.profile.id) {
                return this.$router.push('/')
            }

            if (this.$route.hash === '#damage') {
                return await this.$router.push({name: 'ComplaintDamageList'});
            }

            return await this.$router.push({name: 'ComplaintQualityList'});
        },

        async submitDamageForm() {
            try {
                this.loading = true;
                this.$store.commit('emptyValidation')
                const formData = new FormData();
                formData.append('name', this.form.name);
                formData.append('phone', this.form.phone);
                formData.append('email', this.form.email);
                formData.append('buyer_name', this.form.buyer_name);
                formData.append('subject', this.form.subject);
                formData.append('products', JSON.stringify(this.form.products));
                formData.append('county', this.form.county);
                formData.append('zip', this.form.zip);
                formData.append('city', this.form.city);
                formData.append('street', this.form.street);
                formData.append('house_number', this.form.house_number);
                formData.append('delivery_note_number', this.form.delivery_note_number);
                formData.append('message', this.form.message);

                if (this.form.delivery_note_files) {
                    this.form.delivery_note_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`delivery_note_files[${index}]`, file);
                        }
                    });
                }

                if (this.form.photo_of_dmg_files) {
                    this.form.photo_of_dmg_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`photo_of_dmg_files[${index}]`, file);
                        }
                    });
                }

                const response = await axios.post('complaints/damage/store', formData, config.AXIOS_DEFAULTS_WITH_FILE);
                this.$store.commit('setNotification', [response.message])
                this.resetForm();
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error("Hiba:", error);

                if (error.errors) {
                    this.$store.commit('setValidation', error.errors);
                    this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                    return;
                }

                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        this.$store.commit('setValidation', error.response.data.errors);
                        this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                        return;
                    }

                    if (error.response.status === 413) {
                        this.$store.commit('setNotification', ['A feltöltött fájlok összmérete túl nagy! Próbáljon meg kevesebb vagy kisebb fájlt feltölteni.']);
                        return;
                    }

                    if (error.response.data && error.response.data.message) {
                        this.$store.commit('setNotification', [error.response.data.message]);
                        return;
                    }
                }

                this.$store.commit('setNotification', ['Váratlan hiba történt a mentés során.']);
            }
        },

        async submitQualityForm() {
            try {
                this.loading = true;
                this.$store.commit('emptyValidation')
                const formData = new FormData();
                formData.append('name', this.form.name);
                formData.append('phone', this.form.phone);
                formData.append('email', this.form.email);
                formData.append('buyer_name', this.form.buyer_name);
                formData.append('subject', this.form.subject);
                formData.append('products', JSON.stringify(this.form.products));
                formData.append('county', this.form.county);
                formData.append('zip', this.form.zip);
                formData.append('city', this.form.city);
                formData.append('street', this.form.street);
                formData.append('house_number', this.form.house_number);
                formData.append('installation_status', this.form.installation_status);
                formData.append('installation_date', this.form.installation_date);
                formData.append('delivery_note_number', this.form.delivery_note_number);
                formData.append('message', this.form.message);

                if (this.form.delivery_note_files) {
                    this.form.delivery_note_files.forEach((file, index) => {
                        formData.append(`delivery_note_files[${index}]`, file);
                    });
                }

                if (this.form.photo_of_dmg_files) {
                    this.form.photo_of_dmg_files.forEach((file, index) => {
                        formData.append(`photo_of_dmg_files[${index}]`, file);
                    });
                }

                if (this.form.warranty_file) {
                    formData.append(`warranty_file`, this.form.warranty_file[0]);
                }

                const response = await axios.post('complaints/quality/store', formData, config.AXIOS_DEFAULTS_WITH_FILE);
                this.$store.commit('setNotification', [response.message])
                this.resetForm();
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error("Hiba:", error);

                if (error.errors) {
                    this.$store.commit('setValidation', error.errors);
                    this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                    return;
                }

                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        this.$store.commit('setValidation', error.response.data.errors);
                        this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                        return;
                    }

                    if (error.response.status === 413) {
                        this.$store.commit('setNotification', ['A feltöltött fájlok összmérete túl nagy! Próbáljon meg kevesebb vagy kisebb fájlt feltölteni.']);
                        return;
                    }

                    if (error.response.data && error.response.data.message) {
                        this.$store.commit('setNotification', [error.response.data.message]);
                        return;
                    }
                }

                this.$store.commit('setNotification', ['Váratlan hiba történt a mentés során.']);
            }
        },

        resetForm() {
            this.form = {
                name: '',
                phone: '',
                email: '',
                buyer_name: '',
                zip: '',
                county: '',
                city: '',
                street: '',
                house_number: '',
                installation_status: 'before',
                installation_date: '',
                delivery_note_number: null,
                delivery_note_files: null,
                delivery_note_files_preview: null,
                photo_of_dmg_files: null,
                photo_of_dmg_files_preview: null,
                warranty_file: null,
                warranty_file_preview: null,
                message: ''
            }
        },
    },

    computed: {
        ...mapGetters(['profile']),
    },
}
</script>

<style lang="scss">
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/layout/list-page.scss';
</style>
